import { createAction, createSlice } from "@reduxjs/toolkit";

interface State {
    EquipmentsAboveESP: any[];
    EquipmentsBelowESP: any[];
    ShowSchematicDataInMainReport: boolean;
    ESPEquipmentsForAbove: any[];
    ESPEquipmentsForBelow: any[];
    schematicNotification: {
        show: boolean,
        message: string
        type: string
    };
};

export const initialState: State = {
    EquipmentsAboveESP: [],
    EquipmentsBelowESP: [],
    ShowSchematicDataInMainReport: false,
    ESPEquipmentsForAbove: [],
    ESPEquipmentsForBelow: [],
    schematicNotification: {
        show: false,
        message: "",
        type: ""
    },
};

export const fetchEquipmentsForAboveESP = createAction("schematic/fetchEquipmentsForAboveESP");
export const fetchEquipmentsForBelowESP = createAction("schematic/fetchEquipmentsForBelowESP");

const schematicSlice = createSlice({
    name: 'schematic',
    initialState,
    reducers: {
        setEquipmentsAboveESP: (state, action) => {
            state.EquipmentsAboveESP = action?.payload?.length > 0 ? action?.payload.map((equipment: any) => ({
                ...equipment,
                label: equipment?.accAboveESP,
                value: equipment?.id,
            })) : [];
        },
        setEquipmentsBelowESP: (state, action) => {
            state.EquipmentsBelowESP = action?.payload?.length > 0 ? action?.payload.map((equipment: any) => ({
                ...equipment,
                label: equipment?.accBelowESP,
                value: equipment?.id,
            })) : [];
        },
        setShowSchematicDataInMainReport: (state, action) => {
            state.ShowSchematicDataInMainReport = action?.payload;
        },
        setESPEquipmentsForAbove: (state, action) => {
            state.ESPEquipmentsForAbove = action?.payload;
        },
        setESPEquipmentsForBelow: (state, action) => {
            state.ESPEquipmentsForBelow = action?.payload;
        },
        setSchematicNotification: (state, action) => {
            state.schematicNotification = action?.payload;
        },
    }
});

export const {
    setEquipmentsAboveESP,
    setEquipmentsBelowESP,
    setShowSchematicDataInMainReport,
    setESPEquipmentsForAbove,
    setESPEquipmentsForBelow,
    setSchematicNotification,
} = schematicSlice.actions;

export default schematicSlice.reducer;
